/**
 * Shop policy pages (Terms of Service, Privacy Policy, etc.) render through
 * Shopify's fixed .shopify-policy__container markup, which themes cannot
 * replace with a section -- so this builds the sticky left tab rail by
 * transforming that DOM after it renders, instead of via Liquid. Progressive
 * enhancement only: if this never runs, the page still reads exactly as
 * Shopify's default single-column policy layout.
 */
(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  // Climbs from a node up through ancestors (stopping at `root`) as long as
  // each parent's only meaningful content is that node -- so removing a
  // "Last updated" <em> also takes its <p>, and (for policies with legacy
  // Squarespace markup) the empty wrapper divs around that <p>, instead of
  // leaving empty shells behind.
  function outermostSoleWrapper(node, root) {
    var current = node;
    while (
      current.parentElement &&
      current.parentElement !== root &&
      current.parentElement.textContent.trim() === current.textContent.trim()
    ) {
      current = current.parentElement;
    }
    return current;
  }

  // The policy body always repeats "Last updated: <date>" as its own line,
  // and (so far, on every policy page checked) repeats the page's own title
  // as its first heading. Moving the date up next to <h1> and dropping that
  // redundant heading is a display change only -- the underlying policy
  // text in Shopify Admin is untouched, and any page that doesn't follow
  // this pattern is left exactly as Shopify renders it.
  function relocateTitleAndDate(container, rte) {
    var titleEl = container.querySelector('.shopify-policy__title');
    var h1 = titleEl ? titleEl.querySelector('h1') : null;
    if (!titleEl || !h1) return;

    var pageTitle = h1.textContent.trim().toLowerCase();
    var headings = Array.prototype.slice.call(
      rte.querySelectorAll('h1, h2, h3, h4, h5, h6')
    );
    var duplicateHeading = headings.filter(function (heading) {
      return heading.textContent.trim().toLowerCase() === pageTitle;
    })[0];
    if (duplicateHeading) {
      outermostSoleWrapper(duplicateHeading, rte).remove();
    }

    var textNodes = Array.prototype.slice.call(
      rte.querySelectorAll('em, strong, p, span')
    );
    var lastUpdatedEl = textNodes.filter(function (node) {
      return /^last updated/i.test(node.textContent.trim());
    })[0];
    if (lastUpdatedEl) {
      var dateText = lastUpdatedEl.textContent.trim();
      outermostSoleWrapper(lastUpdatedEl, rte).remove();
      var meta = document.createElement('p');
      meta.className = 'policy-last-updated';
      meta.textContent = dateText;
      titleEl.appendChild(meta);
    }
  }

  function init() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container) return;

    var body = container.querySelector('.shopify-policy__body');
    var rte = body ? body.querySelector('.rte') : null;
    if (!body || !rte) return;

    relocateTitleAndDate(container, rte);

    var headings = Array.prototype.slice.call(rte.querySelectorAll('h3'));
    if (!headings.length) return;

    var row = document.createElement('div');
    row.className = 'policy-toc-row';

    var toc = document.createElement('nav');
    toc.className = 'policy-toc';
    toc.setAttribute('aria-label', 'Sections on this page');
    var list = document.createElement('ul');
    toc.appendChild(list);

    body.classList.add('policy-content');
    body.parentNode.replaceChild(row, body);
    row.appendChild(toc);
    row.appendChild(body);

    var usedIds = {};
    var entries = [];

    headings.forEach(function (heading, index) {
      var id = heading.id;
      if (!id) {
        var base = slugify(heading.textContent) || 'section-' + index;
        id = base;
        var suffix = 1;
        while (usedIds[id] || document.getElementById(id)) {
          id = base + '-' + suffix;
          suffix += 1;
        }
        heading.id = id;
      }
      usedIds[id] = true;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent;
      link.addEventListener('click', function (event) {
        event.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });

      item.appendChild(link);
      list.appendChild(item);
      entries.push({ heading: heading, link: link });
    });

    function setActive(heading) {
      entries.forEach(function (entry) {
        entry.link.classList.toggle('is-active', entry.heading === heading);
      });
    }

    setActive(headings[0]);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (observerEntries) {
          observerEntries.forEach(function (observerEntry) {
            if (!observerEntry.isIntersecting) return;
            var match = entries.filter(function (entry) {
              return entry.heading === observerEntry.target;
            })[0];
            if (match) setActive(match.heading);
          });
        },
        { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
